import { render, staticRenderFns } from "./VariationsProductItem.vue?vue&type=template&id=3a8e43fa&scoped=true&"
import script from "./VariationsProductItem.vue?vue&type=script&lang=js&"
export * from "./VariationsProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e43fa",
  null
  
)

export default component.exports